import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './Sidebar';
import PersonalInfo from './PersonalInfo';
import TNLogo from '../../Constant/Icons/TamilNadu_Logo.png';
import Profile from './components/Profile';
import HomePage from './components/HomePage';
import userIcon from '../../Constant/Icons/user.svg';
import DropdownMenu from './components/DropdownMenu';
import './dashboard.css';
import CertificateUpload from './components/CertificateUpload';
import Application from './components/Application';
import { serverUrl } from '../../Constant/Static/config';
import { AuthContext } from '../../Auth/AuthContext';
import SessionTimer from '../../Auth/SessionTimer';
import Loader from '../../Constant/Custom/Loader';
import CFHome from '../Choicefilling/CFHome';
import Rank from '../Home/Rank';
import CVStatus from '../Home/CVStatus';
import TentativePage from '../Home/TentativePage';
import AllotmentPage from '../Home/AllotmentPage';
import ScrollButton from '../../Modules/Components/ScrollButton'
import Closed from '../../Constant/Custom/Closed';
import Duplicate from '../Home/Duplicate';

function Dashboard() {
  const location = useLocation()

  const { auth, logoutUser } = useContext(AuthContext);
  const [enableRC, setEnableRC] = useState(false);
  const [user, setUser] = useState('');

  const [appStatus, setAppStatus] = useState({
    submitStatus: 'N',
    status: { message: '' },
    flag: 'N'
  });
  const [loading, setLoading] = useState(true);
  const [profileModal, setProfileModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {

    // const fetchCsrfToken = async () => {
    //   try {
    //     const response = await axios.get(`${serverUrl}/api/csrf-token`, {
    //       withCredentials: true  // Ensure cookies are sent
    //     });
    //     setCsrfToken(response.data.csrfToken);  // Set CSRF token
    //   } catch (error) {
    //     console.error('Error fetching CSRF token:', error);
    //   }
    // };
    // fetchCsrfToken();
    const handleRightClick = (e) => {
      if (!enableRC) e.preventDefault();
      // alert("Right-click is disabled!");
    };

    document.addEventListener("contextmenu", handleRightClick);
    const handleKeyPress = (e) => {
      // Disable F12, Ctrl+Shift+I, and Ctrl+Shift+J
      if (
        e.keyCode === 123 || // F12 key
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) // Ctrl + Shift + J or I or C
      ) {
        e.preventDefault();
        // alert("Developer tools are disabled!");
      }

      if (e.key == "k") {
        setEnableRC(true)
      } else {
        setEnableRC(false)
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick); // Cleanup right-click event
      document.removeEventListener("keydown", handleKeyPress); // Cleanup keydown event
    }
  }, [enableRC]);



  useEffect(() => {
    const fetchUserAndStatus = async () => {
      if (auth.user) {
        const typeuser = localStorage.getItem('typeuser');
        // console.log(typeuser);
        setUser(auth.user);
        try {
          const response = await axios.post(`${serverUrl}/api/get-app-status`, {
            appno: auth.user?.appno,
            mobile: auth.user?.mobile,
            email: auth.user?.email,
            typeuser: typeuser
          });
          const { submitStatus = 'N', status = { message: '' }, flag = 'N', CorrectAppnumber = "" } = response.data || {};
          setAppStatus({ submitStatus, status, flag, CorrectAppnumber });
          // console.log();
        } catch (err) {
          console.error('Error fetching status:', err);
        }
        setLoading(false);
      }
    };
    fetchUserAndStatus();
  }, [auth.user, navigate]);


  useEffect(() => {
    const handleReload = () => {
      if (!auth.user) {
        navigate('/login');
      }
    };

    window.addEventListener('beforeunload', handleReload);

    return () => {
      window.removeEventListener('beforeunload', handleReload);
    };
  }, [auth.user, navigate]);

  const handleLogout = async () => {
    try {
      await axios.post(`${serverUrl}/api/logout`, {}, { withCredentials: true });
      if (localStorage.getItem('typeuser') === 'special') {
        navigate('/');
      }
      localStorage.removeItem('userToken');
      localStorage.removeItem('typeuser');
      localStorage.removeItem('sex');
      logoutUser();
    } catch (err) {
      console.error('Logout failed', err);
    }
  };

  const handleProfile = () => {
    setProfileModal(true);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <SessionTimer handleLogout={handleLogout}>
      <div className='app'>
        <Sidebar onRouteChange={navigate} appStatus={appStatus} />
        <div className='content'>
          <div className="header">
            <div className='logo'>
              <img alt='TN' src={TNLogo} width={50} height={50} />
            </div>
            <div className='header-content'>
              <h3>GOVERNMENT OF TAMILNADU</h3>
              <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2026</h4>
            </div>
            <div className='profile'>
              <DropdownMenu user={userIcon} onProfileModal={handleProfile} onLogout={handleLogout} />
            </div>
          </div>

          <ScrollButton />
          <Routes>
            {(appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderDuplicates') ? (<>
              <Route path="/" element={<Duplicate CorrectApplicationNumber={appStatus.CorrectAppnumber} />} />
            </>) :
              (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderSpecialAllotment') ? (<>
                <Route path="/" element={<AllotmentPage />} />
              </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderAllotment') ? (
                <>
                  <Route path="/" element={<AllotmentPage />} />
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderTentative') ? (
                <>
                  <Route path="/" element={<TentativePage />} />
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderChoicefilling') ? (
                <>
                  <Route path="/" element={<Rank />} />
                  <Route path="/choicefilling" element={<CFHome />} />
                  {/* <Route path="/choicefilling" element={<Closed purpose={"Choicefilling has been ended"} />} /> */}
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'rankNotAvailable') ? (
                <>
                  <Route path="/" element={<Closed purpose={"CHECK YOUR ELIGIBILITY"} />} />
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderRank') ? (
                <>
                  <Route path="/" element={<Rank />} />
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag === 'UnderCV') ? (
                <>
                  <Route path="/" element={<CVStatus />} />
                  {(appStatus.status === "Waiting" || appStatus.status === "Application under scrutiny") && <Route path="/certificate-upload" element={<CertificateUpload />} />}
                </>
              ) : (appStatus.submitStatus === 'P' || appStatus.submitStatus === 'Y') && (appStatus.flag != 'UnderSpecialAllotment') ? (
                <>
                  <Route path="/" element={<Application />} />
                  <Route path="/certificate-upload" element={<CertificateUpload />} />
                </>
              ) : (
                <>
                  {/* <Route path="/" element={<Closed purpose={"Registration has been closed"} />} /> */}
                  {/* <Route path="/personalInfo" element={<Closed purpose={"Registration has been closed"} />} /> */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/personalInfo" element={<PersonalInfo />} /> 

                </>
              )}
            <Route path="/about" element={<div>About Content</div>} />
          </Routes>

          {profileModal && <Profile close={() => setProfileModal(false)} />}
        </div>
      </div>
    </SessionTimer>
  );
}

export default Dashboard;
